import { useContext } from 'react';

import { HistogramYFormatterContext } from '../contexts/HistogramYFormatter.context.js';

export const useHistogramYFormatter = () =>
  useContext(HistogramYFormatterContext) ?? [];
